import React, { useState } from 'react';

const Twentyseventheme = ({get_data}) => {
    const [cart, setCart] = useState([]);

    const addToCart = (item) => {
        setCart([...cart, item]);
        alert(`${item.service_name} added to cart!`);
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Clean Slate */
            --bg: #f9fafb;
            --surface: #ffffff;
            --text: #374151;
            --primary: #3b82f6;
            --border: #e5e7eb;
        }

        body { font-family: 'Inter', sans-serif; background: var(--bg); color: var(--text); margin: 0; line-height: 1.5; }
        a { text-decoration: none; color: inherit; transition: 0.2s; }
        a:hover { color: var(--primary); }
        .container { max-width: 1000px; margin: 0 auto; padding: 0 20px; }
        
        .header { background: var(--surface); border-bottom: 1px solid var(--border); padding: 20px 0; }
        .header .container { display: flex; justify-content: space-between; align-items: center; }
        .brand { font-weight: 700; font-size: 1.25rem; color: #111; }
        .nav { display: flex; gap: 20px; font-size: 0.9rem; color: #6b7280; }
        
        .hero { background: var(--surface); padding: 80px 0; text-align: center; border-bottom: 1px solid var(--border); }
        .hero h1 { font-size: 2.5rem; font-weight: 800; color: #111; margin-bottom: 15px; }
        .hero p { color: #6b7280; max-width: 600px; margin: 0 auto 30px; }
        
        .btn { display: inline-block; background: var(--primary); color: white; padding: 10px 20px; border-radius: 6px; font-weight: 500; font-size: 0.9rem; border: none; cursor: pointer; transition: 0.2s; }
        .btn:hover { background: #2563eb; color: white; }
        .btn-text { background: transparent; color: var(--primary); padding: 0; }
        .btn-text:hover { text-decoration: underline; background: transparent; color: var(--primary); }
        
        .section { padding: 60px 0; }
        .section h2 { font-size: 1.5rem; font-weight: 700; margin-bottom: 30px; color: #111; }
        
        .list-grid { display: grid; gap: 20px; }
        .list-item { background: var(--surface); padding: 20px; border: 1px solid var(--border); border-radius: 8px; display: flex; align-items: center; gap: 20px; }
        .icon-box { min-width: 50px; height: 50px; background: #eff6ff; color: var(--primary); border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 1.25rem; }
        
        .product-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 20px; }
        .product-card { background: var(--surface); border: 1px solid var(--border); border-radius: 8px; overflow: hidden; }
        .product-img { width: 100%; height: 150px; object-fit: cover; background: #f3f4f6; }
        .product-body { padding: 15px; }
        .product-body h3 { font-size: 1rem; font-weight: 600; margin-bottom: 5px; }
        .price { font-weight: 700; color: #111; font-size: 0.9rem; }
        
        .footer { border-top: 1px solid var(--border); padding: 40px 0; text-align: center; font-size: 0.85rem; color: #9ca3af; background: var(--surface); margin-top: 60px; }
            `}</style>
            
            <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap" rel="stylesheet" />

            <div className="header">
                <div className="container">
                    <div className="brand">{get_data.service_name}</div>
                    <nav className="nav">
                        <a href="#">Home</a>
                        <a href="#services">Services</a>
                        <a href="#products">Products</a>
                    </nav>
                </div>
            </div>

            <div className="hero">
                <div className="container">
                    <h1>Simply Better.</h1>
                    <p>We focus on what matters: delivering excellence without the noise. High quality services for high quality needs.</p>
                    <a href="#products" className="btn">View Products</a>
                </div>
            </div>

            <div className="container section" id="services">
                <h2>Our Expertise</h2>
                <div className="list-grid">
                    {get_data.categories && get_data.categories.map((item, index) => (
                        <div className="list-item" key={index}>
                            <div className="icon-box">
                                {item.icon ? <img src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} style={{width: '30px', height: '30px'}} alt=""/> : <span>✓</span>}
                            </div>
                            <div>
                                <h3 style={{fontSize: '1.1rem', fontWeight: 600, margin: '0 0 5px'}}>{item.name}</h3>
                                <p style={{margin: 0, fontSize: '0.9rem', color: '#6b7280'}}>{item.description}</p>
                            </div>
                            <div style={{marginLeft: 'auto'}}>
                                <a href="#contact" className="btn-text">Details &rarr;</a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="container section" id="products">
                <h2>Featured Items</h2>
                <div className="product-grid">
                     {get_data.product_services && get_data.product_services.map((item, index) => (
                        <div className="product-card" key={index}>
                            <img src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} className="product-img" alt={item.service_name}/>
                            <div className="product-body">
                                <h3>{item.service_name}</h3>
                                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px'}}>
                                     {item.price && <span className="price">₹{item.price}</span>}
                                     <button onClick={() => addToCart(item)} className="btn" style={{padding: '5px 12px', fontSize: '0.8rem'}}>Add</button>
                                </div>
                            </div>
                        </div>
                     ))}
                </div>
            </div>

            <footer className="footer" id="contact">
                <div className="container">
                    <p>{get_data.service_name} &nbsp; • &nbsp; {get_data.business_location_name}</p>
                    <p>{get_data.email}</p>
                </div>
            </footer>
        </>
    );
};

export default Twentyseventheme;
